// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__p5OcH","logo":"styles_logo__wwi4j","content":"styles_content__M8x_z"};
module.exports.__checksum = "0d1be0f1b672"
